import { render, staticRenderFns } from "./CustomerTransfersView.vue?vue&type=template&id=594b396a&scoped=true&"
import script from "./CustomerTransfersView.vue?vue&type=script&lang=js&"
export * from "./CustomerTransfersView.vue?vue&type=script&lang=js&"
import style0 from "./CustomerTransfersView.vue?vue&type=style&index=0&id=594b396a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594b396a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4088215791/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('594b396a')) {
      api.createRecord('594b396a', component.options)
    } else {
      api.reload('594b396a', component.options)
    }
    module.hot.accept("./CustomerTransfersView.vue?vue&type=template&id=594b396a&scoped=true&", function () {
      api.rerender('594b396a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/Transfers/CustomerTransfersView.vue"
export default component.exports